"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.Scrim = exports.IconContainer = exports.Root = exports.Label = exports.Content = void 0;
const styles_1 = require("@mui/material/styles");
const Icon_1 = __importDefault(require("../../icon/Icon"));
const typography_1 = __importDefault(require("../../typography"));
exports.Content = (0, styles_1.styled)("div")({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    position: "relative",
    zIndex: 1
});
exports.Label = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    fontSize: "14px",
    [theme.breakpoints.up("lg")]: {
        fontSize: "18px"
    }
}));
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    color: theme.colours.white,
    cursor: "pointer",
    position: "absolute",
    bottom: 0,
    top: 0,
    right: 0,
    left: 0
}));
exports.IconContainer = (0, styles_1.styled)("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    height: "16px",
    justifyContent: "center",
    marginBottom: "2px",
    width: "16px",
    [theme.breakpoints.up("lg")]: {
        height: "32px",
        width: "32px"
    }
}));
exports.Scrim = (0, styles_1.styled)("div")(({ theme }) => ({
    background: theme.colours.black,
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0.75,
    right: 0,
    top: 0
}));
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)(({ theme }) => ({
    fill: theme.colours.white,
    fontSize: "1rem",
    [theme.breakpoints.up("lg")]: {
        fontSize: "2rem"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RodW1ibmFpbC9JY29uVGh1bWJuYWlsL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpREFBOEM7QUFDOUMsMkRBQW1DO0FBQ25DLGtFQUEwQztBQUU3QixRQUFBLE9BQU8sR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUNuQyxVQUFVLEVBQUUsUUFBUTtJQUNwQixPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLE1BQU0sRUFBRSxNQUFNO0lBQ2QsY0FBYyxFQUFFLFFBQVE7SUFDeEIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsTUFBTSxFQUFFLENBQUM7Q0FDVixDQUFDLENBQUM7QUFFVSxRQUFBLEtBQUssR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3RELFFBQVEsRUFBRSxNQUFNO0lBQ2hCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixRQUFRLEVBQUUsTUFBTTtLQUNqQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDMUIsTUFBTSxFQUFFLFNBQVM7SUFDakIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsTUFBTSxFQUFFLENBQUM7SUFDVCxHQUFHLEVBQUUsQ0FBQztJQUNOLEtBQUssRUFBRSxDQUFDO0lBQ1IsSUFBSSxFQUFFLENBQUM7Q0FDUixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsYUFBYSxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN6RCxVQUFVLEVBQUUsUUFBUTtJQUNwQixPQUFPLEVBQUUsTUFBTTtJQUNmLE1BQU0sRUFBRSxNQUFNO0lBQ2QsY0FBYyxFQUFFLFFBQVE7SUFDeEIsWUFBWSxFQUFFLEtBQUs7SUFDbkIsS0FBSyxFQUFFLE1BQU07SUFDYixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsTUFBTSxFQUFFLE1BQU07UUFDZCxLQUFLLEVBQUUsTUFBTTtLQUNkO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLEtBQUssR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDakQsVUFBVSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUMvQixNQUFNLEVBQUUsQ0FBQztJQUNULElBQUksRUFBRSxDQUFDO0lBQ1AsUUFBUSxFQUFFLFVBQVU7SUFDcEIsT0FBTyxFQUFFLElBQUk7SUFDYixLQUFLLEVBQUUsQ0FBQztJQUNSLEdBQUcsRUFBRSxDQUFDO0NBQ1AsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFVBQVUsR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDckQsSUFBSSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztJQUN6QixRQUFRLEVBQUUsTUFBTTtJQUNoQixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsUUFBUSxFQUFFLE1BQU07S0FDakI7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9